import React from 'react'

const GradientButton = ({
  type = "button",
  onClick,
  children,
  disabled = false,
  gradientColors = ['var(--theme-primary)', 'var(--theme-secondary)'],
  className = ""
}) => {
  const handleMouseEnter = (e) => {
    e.target.style.background = `linear-gradient(to right, var(--theme-gradient-start), var(--theme-gradient-end))`;
  };

  const handleMouseLeave = (e) => {
    e.target.style.background = `linear-gradient(to right, ${gradientColors[0]}, ${gradientColors[1]})`;
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`text-white font-semibold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none ${className}`}
      style={{
        background: `linear-gradient(to right, ${gradientColors[0]}, ${gradientColors[1]})`,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </button>
  );
};

export default GradientButton